import React, { Fragment, useState } from 'react';
import './Vote.scss';
import VoteOptions from '../../components/VoteOptions/VoteOptions';
import { API_URL } from '../../utils/axios';
import axios from 'axios'
import format from 'date-fns/format'

const Vote = () => {

    const [loadPoll, setLoadPoll] = useState(false);
    const [pin, setPin] = useState("");
    const [thankyoumessage, setThankyoumessage] = useState(false);
    const [pollOptions, setPollOption] = useState([]);
const handlePinChange = (e) => {
    setPin(e.target.value)
}

const handleSubmit =(e) => {
    e.preventDefault();
    axios.defaults.headers['foodrtoken'] = localStorage.getItem("token");
    axios.get(API_URL + '/poll/get/pin/' + pin).then(response => {
        setPollOption(response.data)
        setLoadPoll(true);
    }).catch(error => console.log(error))

}

    return (
        <div className="vote">
            <div className="vote__container">
                {!loadPoll && <form class="vote__pin-container" onSubmit={handleSubmit}>
                    <input type="text" className="vote__pin" name="pin"  placeholder ="Enter your pin" onChange={handlePinChange} value={pin}></input>
                    <button type="submit" className="vote__pin-button">View your poll!</button>
                </form>}
                {loadPoll && <Fragment>
                    {console.log(pollOptions.title, pollOptions.description, pollOptions)}
                {!thankyoumessage && <div className="vote__end-container">
                    <div className="vote__end-top-container">
                        <div className="vote__end-title-container">
                        <p className="vote__end-title">{pollOptions.title}</p>
                        </div>
                        <div className="vote__end-description-container">
                            <p className="vote__end-description">{pollOptions.description}</p>
                        </div>
                    </div>
                    <div className="vote__end-middle-container">
                        <p className="vote__end-message">This poll ends on </p>
                    </div>
                    <div className="vote__end-bottom-container">
                        <p className="vote__end-date">{format(new Date(pollOptions.endDateTime), "MM/dd/yyyy")}</p>
                        <p className="vote__end-at">@ </p>
                        <p className="vote__end-time">{format(new Date(pollOptions.endDateTime), "hh:mm a")}</p>
                    </div>
                </div>}
               {!thankyoumessage &&  <div className="vote__subheader-container">
                    <p className="vote__subheader">Please select one of the following options below</p>
                </div>}
                <div className="vote__options-container">
                    { pollOptions && <VoteOptions pin={pin} pollOptions={pollOptions.pollOption} thankyoumessage={thankyoumessage} 
                    setThankyoumessage={setThankyoumessage}
                    endDateTimeText= {format(new Date(pollOptions.endDateTime), "MM/dd/yyyy") + " @ " + format(new Date(pollOptions.endDateTime), "hh:mm a")}/>}
                </div></Fragment>}
            </div>
        </div>
    );
};

export default Vote;